export default __webpack_public_path__ + "static/setup_jag_flash-426c3ade3929d7eda946151b2d089d05.png";